/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisputeEvidence
 */
export interface DisputeEvidence {
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidence
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidence
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidence
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidence
     */
    uploadedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof DisputeEvidence
     */
    uploadedAt?: number;
}

/**
 * Check if a given object implements the DisputeEvidence interface.
 */
export function instanceOfDisputeEvidence(value: object): value is DisputeEvidence {
    return true;
}

export function DisputeEvidenceFromJSON(json: any): DisputeEvidence {
    return DisputeEvidenceFromJSONTyped(json, false);
}

export function DisputeEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeEvidence {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'url': json['url'] == null ? undefined : json['url'],
        'description': json['description'] == null ? undefined : json['description'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
        'uploadedAt': json['uploadedAt'] == null ? undefined : json['uploadedAt'],
    };
}

export function DisputeEvidenceToJSON(json: any): DisputeEvidence {
    return DisputeEvidenceToJSONTyped(json, false);
}

export function DisputeEvidenceToJSONTyped(value?: DisputeEvidence | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'url': value['url'],
        'description': value['description'],
        'uploadedBy': value['uploadedBy'],
        'uploadedAt': value['uploadedAt'],
    };
}

